const press = {
  newsUrl: 'media',
  pressUrl: 'press',
  news: 'news',
  press: 'press',
  newsArticlesPerPage: 4,
  pressArticlesPerPage: 4,

};

export default press;
